<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['legalperson.code']">
              <a-input :placeholder="language['common.pleaseInput']+language['legalperson.code']" v-model="queryParam.legalpersonCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['legalperson.name']" >
              <a-input :placeholder="language['common.pleaseInput']+language['legalperson.name']" v-model="queryParam.legalpersonName"></a-input>
            </a-form-item>
          </a-col>
            
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search" >{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" >{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'person:add'">{{language['common.insertButton']}}</a-button>
      <a-button type="primary" icon="download" v-has="'person:export'" @click="handleExportXls('法人表')">{{language['common.exportButton']}}</a-button>
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu v-has="'person:batchDelete'" slot="overlay">
          <a-menu-item key="1"  @click="batchDel"><a-icon type="delete" v-has="'person:batchDelete'"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}}
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a> {{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected"> {{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

      <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'person:edit'">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a  class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a v-has="'person:detail'" @click="handleDetail(record)" >{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => handleDelete(record.id)">
                  <a v-has="'person:delete'">{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <ep-person-modal ref="modalForm" @ok="modalFormOk"></ep-person-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EpPersonModal from './modules/EpPersonModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'EpPersonList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EpPersonModal
    },
    data () {
      return {
        description: '厂区表管理页面',

        url: {
          list: "/sys/epPerson/pagelist",
          delete: "/sys/epPerson/delete",
          deleteBatch: "/sys/epPerson/deleteBatch",
          exportXlsUrl: "/sys/epPerson/exportXls",
          importExcelUrl: "/sys/epPerson/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns() {
        if (this.language) {
          return [
            {
              title: this.language['common.serialNumber'],
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['legalperson.code'],
              align:"center",
              sorter: true,
              dataIndex: 'legalpersonCode',
              width:200,
            },
            {
              title:this.language['legalperson.name'],
              align:"center",
              sorter: true,
              dataIndex: 'legalpersonName',
              width:300,
            },
            {
              title:this.language['basedata.remark'],
              align:"center",
              sorter: true,
              dataIndex: 'remark'
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
      }
    },
    methods: {
      initDictConfig(){
      },

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>